import { render, staticRenderFns } from "./ActivityEmotionSpacePane.vue?vue&type=template&id=b2bda1d8&scoped=true"
import script from "./ActivityEmotionSpacePane.vue?vue&type=script&lang=js"
export * from "./ActivityEmotionSpacePane.vue?vue&type=script&lang=js"
import style0 from "./ActivityEmotionSpacePane.vue?vue&type=style&index=0&id=b2bda1d8&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2bda1d8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b2bda1d8')) {
      api.createRecord('b2bda1d8', component.options)
    } else {
      api.reload('b2bda1d8', component.options)
    }
    module.hot.accept("./ActivityEmotionSpacePane.vue?vue&type=template&id=b2bda1d8&scoped=true", function () {
      api.rerender('b2bda1d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/AppPage/ HundredDayOath/compoents/ActivityEmotionSpacePane.vue"
export default component.exports